import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-white" data-id="element-112">
      <div className="max-w-3xl mx-auto bg-blue-50 border-4 border-blue-200 rounded-2xl p-8 md:p-12 text-center shadow-lg relative overflow-hidden" data-id="element-113">
        <div className="absolute -right-10 -top-10 text-blue-100 opacity-50" data-id="element-114">
          <ShieldCheckIcon className="w-64 h-64" data-id="element-115" />
        </div>

        <div className="relative z-10" data-id="element-116">
          <ShieldCheckIcon className="w-20 h-20 text-blue-600 mx-auto mb-6" data-id="element-117" />
          <h2 className="text-4xl font-black text-gray-900 mb-6" data-id="element-118">
            🛡 Garantía sin riesgo
          </h2>
          <p className="text-2xl text-gray-800 font-bold mb-4" data-id="element-119">
            Prueba RESET CORPORAL 30D durante 7 días.
          </p>
          <p className="text-xl text-gray-700 mb-6" data-id="element-120">
            Si sientes que no es para ti, puedes solicitar el 100% de tu dinero.
          </p>
          <p className="text-2xl font-black text-blue-700 uppercase tracking-wide" data-id="element-121">
            Sin preguntas. Sin riesgo.
          </p>
        </div>
      </div>
    </section>;
}